import { Reducer } from 'redux';
import {
  ResetPasswordState,
  ResetPasswordActionTypes,
  RESET_PASSWORD_INPROGESS,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  VERIFY_RESET_PASSWORD_INPROGESS,
  VERIFY_RESET_PASSWORD_SUCCESS,
  VERIFY_RESET_PASSWORD_FAILURE,
} from './types';
import * as Bixby from '$/core';

const initialState: ResetPasswordState = {
  isLoading: false,
  error: '',
  success: false,
  tokenInvalid: false,
};

const resetPasswordReducer: Reducer<ResetPasswordState> = (
  state = initialState,
  action: ResetPasswordActionTypes
): ResetPasswordState => {
  switch (action.type) {
    case VERIFY_RESET_PASSWORD_INPROGESS:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case VERIFY_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tokenInvalid: action.payload === false,
      };
    case VERIFY_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        success: false,
      };
    case RESET_PASSWORD_INPROGESS:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: Bixby.API.getErrorMessage((action.payload || {}) as Error),
        success: false,
      };
    default:
      return state;
  }
};
export default resetPasswordReducer;
